import React from 'react';
import { VStack } from '@chakra-ui/react';
import { Campaign, Collab } from '@foodfluence/shared';
import { getCollabContentRequirements } from '../../../../utils/contentUtils';
import UgcDeliverablesSection from './UgcDeliverablesSection';

interface UgcCreativeBriefProps {
  campaign: Campaign;
  collab?: Collab;
  clientName?: string;
}

const UgcCreativeBrief: React.FC<UgcCreativeBriefProps> = ({ campaign, collab, clientName }) => {
  const resolved = getCollabContentRequirements(collab, campaign);
  if (!resolved || Object.keys(resolved).length === 0) {
    return null;
  }

  return (
    <VStack align="stretch" spacing={5}>
      <UgcDeliverablesSection campaign={campaign} collab={collab} clientName={clientName} />
    </VStack>
  );
};

export default UgcCreativeBrief;
